import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideBar from "../organisms/SideBar";
import Footer from "../organisms/Footer";
import Header from "../organisms/Header";

const RootPage = () => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const excludedRoutes = [
    "/wishlist",
    "/all-users",
    "/profile-description",
    "all-users",
    "/project-details",
    "/news-description",
    "/all-carbon-credit",
  ];
  const shouldRenderHeader = !excludedRoutes.some(route => location.pathname.startsWith(route));

  return (
    <main>
      <div className="flex">
        <SideBar />
        <div className="w-full flex flex-col">
          {shouldRenderHeader && <Header isHomePage={isHomePage} />}
          <Outlet />
        </div>
      </div>
      <div className='bg-gray-100 p-2 '></div>
      <Footer />
    </main>
  );
};

export default RootPage;
